"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMarkersFavorite = function SvgIconMarkersFavorite(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "markers favorite icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Markers Favorite Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.947 32.208a1.42 1.42 0 00-1.894 0L10.356 43.635C9.452 44.449 8 43.814 8 42.603V4h32v38.603c0 1.21-1.452 1.846-2.356 1.032L24.947 32.208zm-.212-21.326a.801.801 0 00-1.47 0l-1.812 3.92a.821.821 0 01-.624.473l-4.123.591c-.676.098-.946.968-.454 1.463l3.004 3.013a.88.88 0 01.238.767l-.737 4.284c-.12.703.588 1.241 1.189.904l3.668-2.057a.792.792 0 01.772 0l3.668 2.057c.601.337 1.31-.201 1.19-.904l-.738-4.284a.88.88 0 01.24-.767l3.002-3.013c.492-.495.222-1.365-.454-1.463l-4.123-.59a.821.821 0 01-.624-.474l-1.812-3.92z"
  }));
};

var _default = SvgIconMarkersFavorite;
exports.default = _default;